module.exports = __webpack_public_path__ + "img/relation-img.903ab10f.svg";